/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import rothko from "modules/rothko";
import { addVisibilityWatcher } from "modules/run-loop";
import template from "templates/modules/lyst_cards_grid";

export default baustein.register("lyst-cards-grid", {
    template: template,

    onInsert() {
        this._removeVisiblityWatcher = addVisibilityWatcher(this.el, visible => {
            if (visible) {
                this.fetchAndRender();
                this._removeVisiblityWatcher();
            }
        });
    },

    onRemove() {
        if (this._removeVisiblityWatcher) {
            this._removeVisiblityWatcher();
        }
    },

    fetchAndRender: function() {
        rothko
            .fetch("modules/lyst_cards_grid", {
                gender: this.options.gender,
                subcategory: this.options.subcategory,
                category: this.options.category,
                product_type: this.options.productType,
                collection_id: this.options.collectionId,
                collection_owner_gender: this.options.collectionOwnerGender
            })
            .then(lystCardsGrid => {
                this.setRenderContext({
                    lyst_cards_grid: lystCardsGrid,
                    modifier: this.options.modifier
                });
            });
    }
});

